import React from 'react'
import './virtualScreen.scss'
import ProgressBubbles from '../../Global/ProgressBubbles';
import ListeningStatusMicUI from '../../Global/ListeningStatusMicUI';
import cx from 'classnames'

export default function VirtualScreen(props) {

    const classes = cx({
        "paper-container": true,
        "transparent": props.invisible
    })

    return <div className={classes}>
        <div className="paper-top"></div>
        <div className="paper-inner-container">
            <div className="paper-left"></div>
            {props.children}
            <div className="paper-right"></div>
        </div>
        <div className="paper-bottom">
            {!props.isCorrection && props.listeningStatusEnabled &&
                <div className="mic-container">
                    <ListeningStatusMicUI/>
                </div>
            }
            <ProgressBubbles
                selectedIndex={props.pageIndex}
                highlightPast={true}
                numBubbles={props.storyLength}
                smallBubbles={false}
                shape={"rhombus"}
            />
        </div>
    </div>
}